import React from 'react';

import { notEmpty } from 'utils/ramdaAdditions';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import TablePerson from 'components/cards/person/table/TablePerson';

export const PersonEducations = ({list}) => notEmpty(list) ? (
    <div>
        <DefinitionHeader translate="person.education.title" iconType="graduation-cap" />
        <TablePerson items={list} table="education" />
    </div>
) : null;
